/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_DueInputs */

const cs_col_due = /** @type {(inputs: Col_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termín`)
};

const en_col_due = /** @type {(inputs: Col_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due`)
};

/**
* | output |
* | --- |
* | "Due" |
*
* @param {Col_DueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_due = /** @type {((inputs?: Col_DueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_DueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_due(inputs)
	return cs_col_due(inputs)
});